import '@components/support-drawer/supportDrawer.scss';
import Accordion from '@components/accordion/Accordion';

const publicNoticesHelpContent = {
  header: 'Public Notices',
  body: (
    <div className='help-content'>
      <p>
        The following screens will provide you with several options to search for, and provide comments on, projects
        that are currently being evaluated by the USACE Regulatory Program pursuant to Section 404 of the Clean Water
        Act, Section 10 of the Rivers and Harbors Act, and/or Section 103 of the Marine Protection, Research, and
        Sanctuaries Act. Once you have found the specific project you are interested in, you may enter your comments
        directly into the Comments field that is provided (note that this option is limited to 4,000 characters) or you
        may upload your comments and any attachments directly to the RRS. Your comments will be provided directly to the
        USACE Project Manager that is responsible for the evaluation of the project.
      </p>
      <p>You may search for a specific Public Notice by providing any of the following information:</p>
      <ul>
        <li>The ORM ID number - this will take you to a specific project.</li>
        <li>
          The USACE District in which the project is located - you will need to search the list provided within the
          Public Notice page for the project you are interested in.
        </li>
        <li>
          Search by a specific keyword from the following list (for example - entering "Pipeline" will return all
          projects where the word "Pipeline" is contained in the Public Notice text).
        </li>
        <li>Search by project or applicant name (using the Search icon).</li>
        <li>Search by location from the map view. Search option.</li>
      </ul>
    </div>
  ),
};

const regulatorDashboardHelpContent = {
  header: 'Regulator Dashboard Help',
  body: (
    <div className='accordion-list padding-2'>
      <Accordion title='How Do I View Details about an Inquiry?'>
        <p>
          To view details about an inquiry, click the "View Summary" option on the inquiry you would like to view. This
          will open a modal displaying the details of the inquiry, including the reason for the inquiry as well as the
          requestor name and email, inquiry category, request type, location, and status.
        </p>
      </Accordion>
      <Accordion title='Why Do I Only See Some Districts?'>
        You only see districts for active inquiries for requests in districts that you support. You can specify which
        districts you support in your user profile.
      </Accordion>
      <Accordion title='Tabbed Views of Inquiries'>
        Each tabbed view displays a different set of inquiries.
        <ul>
          <li>
            <strong>Unclaimed Inquiries</strong>: Displays all inquiries that have not been claimed by a regulator for
            the districts you support.
          </li>
          <li>
            <strong>My Claimed Inquiries</strong>: Displays all inquiries that you have claimed. You can filter this
            list by Category, District, or Status.
          </li>
          <li>
            <strong>All Inquiries</strong>: Displays all open help inquiries. You can filter this list by Category,
            District, or Status.
          </li>
        </ul>
      </Accordion>
      <Accordion title="Why Can't I View the Request for an Unclaimed Inquiry?">
        You can only view requests for inquiries that you have claimed. Once you have claimed an inquiry you may view
        the request in read-only mode.
      </Accordion>
      <Accordion title='Claiming an Inquiry'>
        To claim an inquiry, click the "Claim Inquiry" option on the inquiry you would like to address. This will assign
        the inquiry to you and it will appear in your My Claimed Inquiries tab.
      </Accordion>
      <Accordion title='Completing a Claimed Inquiry'>
        Once you've completed your work on a claimed inquiry, you can click the "Complete Help Inquiry" option. This
        will change the status of the inquiry to "Completed" and it will no longer appear in your list of claimed
        inquiries.
      </Accordion>
      <Accordion title='Unclaiming/Unassigning yourself from a Claimed Inquiry'>
        If you need to unassign yourself from a claimed inquiry, you can click the "Unclaim Help Inquiry" option. This
        will change the status of the inquiry to "Open" and it will no longer appear in your list of claimed inquiries.
      </Accordion>
    </div>
  ),
};

const publicModuleHelpContent = {
  '/public-notices': publicNoticesHelpContent,
};

const regulatorHelpContent = {
  '/dashboard': regulatorDashboardHelpContent,
};

const helpContentByRole = {
  'USACE Regulator': regulatorHelpContent,
};

const getHelpContentPathKey = (path = '') => {
  if (path === '/forms' || path.startsWith('/forms/')) return '/forms';
  return path;
};

export const getPublicModuleHelpContent = (path = '') => {
  const pathKey = getHelpContentPathKey(path);

  return publicModuleHelpContent[pathKey] || null;
};

export const getHelpContent = (path, userRole) => {
  const pathKey = getHelpContentPathKey(path);

  return getPublicModuleHelpContent(path) || helpContentByRole[userRole]?.[pathKey] || null;
};

export const hasHelpContent = (path = '', userRole) => {
  const content = getHelpContent(path, userRole);
  return Boolean(content);
};
